import _ from 'lodash';

let NumberDriver = {};

NumberDriver.driverVET = { '2018': 5 };
NumberDriver.driverRAI = { '2018': 7 };
NumberDriver.driverERI = { '2018': 9 };
NumberDriver.driverVES = { '2018': 33 };
NumberDriver.driverSAI = { '2018': 55 };
NumberDriver.driverRIC = { '2018': 3 };
NumberDriver.driverBOT = { '2018': 77 };
NumberDriver.driverHAM = { '2018': 44 };
NumberDriver.driverVAN = { '2018': 2 };
NumberDriver.driverALO = { '2018': 14 };
NumberDriver.driverGAS = { '2018': 10 };
NumberDriver.driverHAR = { '2018': 28 };
NumberDriver.driverSIR = { '2018': 35 };
NumberDriver.driverSTL = { '2018': 18 };
NumberDriver.driverGRO = { '2018': 8 };
NumberDriver.driverLEC = { '2018': 16 };
NumberDriver.driverMAG = { '2018': 20 };
NumberDriver.driverHUL = { '2018': 27 };
NumberDriver.driverOCO = { '2018': 31 };
NumberDriver.driverPER = { '2018': 11 };

const numberForDriver = (shortName, year, def = null) => {
    return _.get(NumberDriver, `driver${shortName}.${year}`, def);
};

export default NumberDriver;

export { numberForDriver };



/** WEBPACK FOOTER **
 ** ../src/widgets/helpers/NumberForDriver.js
 **/